import React from 'react';
import { isSrReferralCancelled, Referral } from '../../services/apiService';

interface SrChangeBadgeProps {
  referral: Referral;
}

export const SrChangeBadge: React.FC<SrChangeBadgeProps> = ({ referral }) => {
  if (
    referral.was_completed_at_cancel &&
    isSrReferralCancelled(referral) &&
    !referral.indici_cancel_acknowledged_at
  ) {
    return <span className="badge badge-danger" style={{ marginInlineStart: 6 }}>Action required</span>;
  }

  if (isSrReferralCancelled(referral)) {
    return <span className="badge badge-danger" style={{ marginInlineStart: 6 }}>Cancelled by SR</span>;
  }

  if (referral.latest_addendum_at) {
    return <span className="badge badge-warning" style={{ marginLeft: 6 }}>Addendum</span>;
  }

  return null;
};
